// Components==============
import React from 'react';
import BoomHut from '../Buildings/BoomHut';
import Camper from '../Buildings/Camper';
import Huis from '../Buildings/Huis';
import Kasteel from '../Buildings/Kasteel';
import LuchtBallon from '../Buildings/LuchtBallon';
import Rocket from '../Buildings/Rocket';
import Tent from '../Buildings/Tent';
import { BuildingTypes, Colors, GroundPlanes } from '../Login';
import './StartpointWrapper.module.scss';
// =========================

type Props = {
    selectedColor: Colors;
    buildingType: BuildingTypes;
    groundPlane: GroundPlanes;
};

export default function StartpointWrapper({
    selectedColor,
    buildingType,
    groundPlane,
}: Props) {
    return (
        <div styleName="startpoint-wrapper">
            <img
                alt="isometic-tile"
                styleName="ground-plane"
                src={`/images/login/groundplanes/ondergrond-${groundPlane}.svg`}
            />
            <>
                {buildingType === 'tent' && (
                    <Tent selectedColor={selectedColor} />
                )}
                {buildingType === 'huis' && (
                    <Huis selectedColor={selectedColor} />
                )}
                {buildingType === 'luchtballon' && (
                    <LuchtBallon selectedColor={selectedColor} />
                )}
                {buildingType === 'kasteel' && (
                    <Kasteel selectedColor={selectedColor} />
                )}

                {buildingType === 'boomhut' && (
                    <BoomHut selectedColor={selectedColor} />
                )}
                {buildingType === 'camper' && (
                    <Camper selectedColor={selectedColor} />
                )}
                {buildingType === 'raket' && (
                    <Rocket selectedColor={selectedColor} />
                )}
            </>
        </div>
    );
}
